import { dialog, InputJson, toDisplayCase } from "../../../../nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navbar";
import FormFactory from "../../../../components/FormFactory";
import DialogModal from "../../../../components/Dialog";
import DialogTable from "../../../../components/DialogTable";
import BreakdownTable from "../../../../components/BreakdownTable";
import ReceivableItemFormPresenter from "./ReceivableItemFormPresenter";
import ReceivableDetails from "./components/ReceivableDetails";
import "./receive.css";
import { computePartialCosts } from "../../../../componentCostUtils";
import PizzaLoader from "../../../../components/PizzaLoader";

class ReceivableItemFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      selectedRawIds: [],
      loading: false,
    };
    this.presenter = new ReceivableItemFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    // try route state first
    const fromNav = this.props.location?.state?.payload;
    // fallback to sessionStorage if page was refreshed
    const fromStorage = sessionStorage.getItem("receivable_items_import");
    const payload = fromNav || (fromStorage ? JSON.parse(fromStorage) : null);

    if (payload) {
      this.setState({ object: payload });
    }
  }

  getCollectionName() {
    return "receivable_item";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  handleOpenRaw() {
    const schema = this.getSchema("raw_materials");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.raw_materials || [];

              console.log("exxx", existing);

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const existingItem = mergedMap.get(item.id);
                mergedMap.set(item.id, {
                  ...item,
                  quantity: existingItem?.quantity || item.quantity || "",
                  remaining: 0,
                  received: existingItem?.quantity || item.quantity || "",
                });
              }

              return {
                object: {
                  ...prev.object,
                  raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleDeleteSelected() {
    const { selectedRawIds, object } = this.state;
    const updated = (object.raw_materials || []).filter(
      (item) => !selectedRawIds.includes(item.id)
    );

    this.setState({
      object: {
        ...object,
        raw_materials: updated,
      },
      selectedRawIds: [], // reset after delete
    });
  }

  onChange(value, field) {
    if (field === "remarks") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasQuantity: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = (this.state.object.raw_materials || []).map(
      (item) => item.id
    );
    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);
    this.setState({ selectedRawIds: updated });
  };

  handleChangeQuantity = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      quantity: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeReference = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      reference: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeWarehouse = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      warehouse: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  handleChangeDiscount = (e, index) => {
    const value = e.target.value;
    const updatedMaterials = [...(this.state.object.raw_materials || [])];
    updatedMaterials[index] = {
      ...updatedMaterials[index],
      discount: value,
    };

    this.setState((prev) => ({
      object: {
        ...prev.object,
        raw_materials: updatedMaterials,
      },
    }));
  };

  onSaveDraft() {
    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit("Draft")}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  onPartiallyReceive(status) {
    // this.presenter.submit("Partially Receive");
    const toNum = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };
    const rawMaterials = computePartialCosts(
      this.state.object.raw_materials || []
    ).map((item) => ({
      ...item,
      totalAmount: String((toNum(item.cost) * toNum(item.quantity)).toFixed(2)),
      sync:
        status === "Draft"
          ? "Not Add"
          : status === "Partially Receive"
          ? item?.quantity !== item?.received
            ? "Partial Add"
            : "Full Add"
          : status === "Received"
          ? item?.quantity === item?.received
            ? "Full Add"
            : ""
          : "",
      added:
        status === "Partially Receive"
          ? toNum(item?.added) + toNum(item?.quantity)
          : 0,
      remaining:
        status === "Partially Receive"
          ? toNum(item?.received) - toNum(item?.added) - toNum(item?.quantity)
          : item?.remaining,
    }));

    console.log("rarara", rawMaterials);
    console.log("stats", status);

    if (status === "Partially Receive") {
      const materials = rawMaterials || [];

      // 1) Guard: stop if any item has remaining < 0
      const negatives = materials.filter((item) => Number(item?.remaining) < 0);

      if (negatives.length) {
        const list = negatives
          .map(
            (i) =>
              `${i?.itemName || "Unnamed item"} (remaining: ${Number(
                i?.remaining
              )})`
          )
          .join(", ");

        const alertMessage =
          negatives.length === 1
            ? `The item ${list} has a negative remaining quantity. Please adjust the quantity.`
            : `Some items have negative remaining quantities: ${list}. Please adjust the quantities.`;

        dialog.fire({
          html: (
            <DialogModal
              icon="bi bi-exclamation-triangle-fill"
              iconColor="#f59f00"
              title="Invalid Quantities"
              message={alertMessage}
              isCancelButton={false}
              onSubmit={() => {
                dialog.close();
                this.hideProgressDialog();
              }}
              onClose={() => dialog.close()}
            />
          ),
          footer: false,
        });
        return false; // stop here; invalid input
      }

      // 2) Existing checks (pending partial, fully matched, etc.)
      const hasPendingPartial = materials.some(
        (item) => Number(item?.remaining) > 0 && item?.sync === "Partial Add"
      );

      if (!hasPendingPartial) {
        const fullyMatched = materials.filter(
          (item) =>
            Number(item?.remaining) === 0 &&
            (item?.sync === "Partial Add" || item?.sync === "Full Add")
        );

        if (fullyMatched.length) {
          const names = fullyMatched
            .map((i) => i?.itemName || "Unnamed item")
            .join(", ");
          const alertMessage =
            fullyMatched.length === 1
              ? `Item ${names} has matching total with received quantity. Click "Confirm Fully Receipt" to complete the process.`
              : `All Items have matching totals with received quantities. Click "Confirm Fully Receipt" to complete the process.`;

          dialog.fire({
            html: (
              <DialogModal
                icon="bi bi-question-octagon-fill"
                iconColor="#82c14a"
                title="Confirm"
                message={alertMessage}
                buttonTitle="Confirm Fully Receipt"
                isCancelButton={true}
                onSubmit={() => {
                  // this.onConfirmFullReceipt();
                  this.presenter.submit("Received");
                  // this.hideProgressDialog();
                }}
                onClose={() => dialog.close()}
              />
            ),
            footer: false,
          });
          return false;
        }
      }

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Confirm to Proceed"
            message="Are you sure want to continue this action?"
            isCancelButton={true}
            onSubmit={() => this.presenter.submit("Partially Receive")}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    }

    // dialog.fire({
    //   html: (
    //     <DialogModal
    //       icon="bi bi-question-octagon-fill"
    //       iconColor="#82c14a"
    //       title="Confirm to Proceed"
    //       message="Are you sure want to continue this action?"
    //       isCancelButton={true}
    //       onSubmit={() => this.presenter.submit("Partially Receive")}
    //       onClose={() => dialog.close()}
    //     />
    //   ),
    //   footer: false,
    // });
  }

  onConfirmFullReceipt(status) {
    const params = this.getParams();
    console.log("Params", params);
    const toNum = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : 0;
    };

    console.log(
      "this.state.object.raw_materials",
      this.state.object.raw_materials
    );
    const rawMaterials = computePartialCosts(
      this.state.object.raw_materials || []
    ).map((item) => ({
      ...item,
      totalAmount: String((toNum(item.cost) * toNum(item.quantity)).toFixed(2)),
      sync:
        status === "Draft"
          ? "Not Add"
          : status === "Received"
          ? item?.quantity !== item?.received
            ? "Partial Add"
            : "Full Add"
          : status === "Received"
          ? item?.quantity === item?.received
            ? "Full Add"
            : ""
          : "",
      added:
        status === "Received" ? toNum(item?.added) + toNum(item?.quantity) : 0,
      ...(params?.name !== "manual" && {
        remaining:
          status === "Received"
            ? toNum(item?.received) - toNum(item?.added) - toNum(item?.quantity)
            : item?.remaining,
      }),

      received:
        status === "Received"
          ? toNum(item?.received) - toNum(item?.added) - toNum(item?.quantity)
          : item?.remaining,
    }));

    console.log("rarara", rawMaterials);
    console.log("stats", status);

    if (status === "Received") {
      const materials = rawMaterials || [];

      // 1) Guard: stop if any item has remaining < 0
      const negatives = materials.filter((item) => Number(item?.remaining) < 0);
      console.log("nega", negatives);
      if (negatives.length) {
        const list = negatives
          .map(
            (i) =>
              `${i?.itemName || "Unnamed item"} (remaining: ${Number(
                i?.remaining
              )})`
          )
          .join(", ");

        const alertMessage =
          negatives.length === 1
            ? `The item ${list} has a negative remaining quantity. Please adjust the quantity.`
            : `Some items have negative remaining quantities: ${list}. Please adjust the quantities.`;

        dialog.fire({
          html: (
            <DialogModal
              icon="bi bi-exclamation-triangle-fill"
              iconColor="#f59f00"
              title="Invalid Quantities"
              message={alertMessage}
              isCancelButton={false}
              onSubmit={() => {
                dialog.close();
                this.hideProgressDialog();
              }}
              onClose={() => dialog.close()}
            />
          ),
          footer: false,
        });
        return false; // stop here; invalid input
      }

      // 2) Existing checks (pending partial, fully matched, etc.)
      const hasPendingPartial = materials.some(
        (item) => Number(item?.remaining) > 0 && item?.sync === "Partial Add"
      );

      console.log("hashas", hasPendingPartial);

      if (hasPendingPartial) {
        const fullyMatched = materials.filter(
          (item) =>
            Number(item?.remaining) > 0 &&
            (item?.sync === "Partial Add" || item?.sync === "Full Add")
        );

        console.log("fullyly", fullyMatched);

        if (fullyMatched.length) {
          const names = fullyMatched
            .map((i) => i?.itemName || "Unnamed item")
            .join(", ");
          const alertMessage =
            fullyMatched.length === 1
              ? `Item ${names} has matching total with received quantity, but some items are still partially received. Click "Partial Receive" to continue the process.`
              : `Some items have matching totals, but others are still partially received. Click "Partially Receive" to continue the process.`;

          dialog.fire({
            html: (
              <DialogModal
                icon="bi bi-question-octagon-fill"
                iconColor="#82c14a"
                title="Confirm"
                message={alertMessage}
                buttonTitle="Partially Receive"
                isCancelButton={true}
                onSubmit={() => {
                  // this.onConfirmFullReceipt();
                  this.presenter.submit("Partially Receive");
                  // this.hideProgressDialog();
                }}
                onClose={() => dialog.close()}
              />
            ),
            footer: false,
          });
          return false;
        }
      }

      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Confirm to Proceed"
            message="Are you sure want to continue this action?"
            isCancelButton={true}
            onSubmit={() => this.presenter.submit("Received")}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    }
  }

  onClickBack() {
    this.presenter.onClickBack();
    sessionStorage.removeItem("receivable_items_import");
  }

  render() {
    const object = this.state.object;
    const params = this.getParams();
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />

        <div className="overflow-auto">
          {this.state.loading && (
            <div className="loading-overlay">
              {/* <ProgressState /> */}
              {/* <Loader /> */}
              <div
                style={{
                  minHeight: "40vh",
                  display: "grid",
                  placeItems: "center",
                }}
              >
                <PizzaLoader
                  size={120}
                  speedSec={1.1}
                  pepperoni={7}
                  label="Baking your data…"
                />
              </div>
            </div>
          )}
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => {
                    this.navigateBack();
                    sessionStorage.removeItem("receivable_items_import");
                  }}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {params.view === "view"
                  ? "View " +
                    (schema.label || toDisplayCase(this.getCollectionName()))
                  : label +
                    (schema.label || toDisplayCase(this.getCollectionName()))}
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form
                // onSubmit={this.onSubmitForm.bind(this)}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {object?.id && params.view === "view" ? (
                          <ReceivableDetails object={object} />
                        ) : (
                          <FormFactory
                            schema={schema}
                            object={object}
                            onChange={this.onChange.bind(this)}
                            excludeFields={[
                              "raw_materials",
                              "cost",
                              "createdBy",
                              "updatedBy",
                              "status",
                            ]}
                          />
                        )}
                      </>
                    )}
                  </div>

                  <BreakdownTable
                    title="Item List"
                    data={object.raw_materials || []}
                    selectedIds={this.state.selectedRawIds}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onChange={this.handleChangeQuantity}
                    onAdd={() => this.handleOpenRaw()}
                    onDelete={() => this.handleDeleteSelected()}
                    // onPriceChange={}
                    onReferenceChange={this.handleChangeReference}
                    onWarehouseChange={this.handleChangeWarehouse}
                    // onNetPriceChange={}
                    onDiscountChange={this.handleChangeDiscount}
                    disableAdd={!this.state.hasQuantity && !this.getObjectId()}
                    hasQuantity={this.state.hasQuantity || !!this.getObjectId()}
                    showUOM={false}
                    showPrice={true}
                    showReference={false}
                    showWarehouse={true}
                    showDetailsRow={false}
                    showRemaining={true}
                    disableQty={params.view === "view" ? true : false}
                    showAddButton={
                      ["Partially Receive", "Received"].includes(object?.status)
                        ? false
                        : true
                    }
                  />

                  <div className="mt-4 text-center">
                    {object?.id && params.view === "view" ? (
                      <button
                        type="button"
                        className="btn fs-sm text-white w-25"
                        onClick={this.onClickBack.bind(this)}
                        style={{ backgroundColor: "#82c14a" }}
                      >
                        Back
                      </button>
                    ) : (
                      <div className="row g-3 mt-3">
                        <div className="col-12 col-md-6">
                          <button
                            type="button"
                            className="btn w-100 py-2 fw-semibold"
                            onClick={this.onClickBack.bind(this)}
                            style={{
                              backgroundColor: "#d1d1d1",
                              color: "#000",
                              borderRadius: 8,
                            }}
                          >
                            <i className="bi bi-arrow-left me-2"></i>
                            Back
                          </button>
                        </div>

                        <div className="col-12 col-md-6">
                          {object.status !== "Draft" &&
                            object.status !== "Partially Receive" && (
                              <button
                                type="button"
                                className="btn w-100 py-2 text-white fw-semibold"
                                onClick={this.onSaveDraft?.bind(this)}
                                style={{
                                  backgroundColor: "#2E88A7",
                                  borderRadius: 8,
                                }}
                              >
                                <i className="bi bi-file-earmark-text me-2"></i>
                                Save as Draft
                              </button>
                            )}
                        </div>

                        <div className="col-12 col-md-6">
                          <button
                            type="button"
                            className="btn w-100 py-2 text-white fw-semibold"
                            onClick={this.onConfirmFullReceipt?.bind(
                              this,
                              "Received"
                            )}
                            style={{
                              backgroundColor: "#82c14a",
                              borderRadius: 8,
                            }}
                          >
                            <i className="bi bi-check-circle me-2"></i>
                            Confirm Full Receipt
                          </button>
                        </div>

                        <div className="col-12 col-md-6">
                          <button
                            type="button"
                            className="btn w-100 py-2 fw-semibold"
                            onClick={this.onPartiallyReceive?.bind(
                              this,
                              "Partially Receive"
                            )}
                            style={{
                              backgroundColor: "#FFCC33",
                              color: "#000",
                              borderRadius: 8,
                            }}
                          >
                            <i className="bi bi-box-seam me-2"></i>
                            Partially Receive
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ReceivableItemFormPage);
